export const PERMISSION_FLAGS = [
  'canCreateCompany',
  'canEditCompany',
  'canRemoveCompany',
  'canCreateUser',
  'canEditUser',
  'canRemoveUser',
  'canAddDriver',
  'canViewActivities',
  'canEditActivities',
  'canEditActivityDay',
  'canEditGpsData',
  'canGenerateAttestation',
  'canViewDelegations',
  'canEditDelegations',
  'canViewBillingData',
  'canEditBillingData',
  'canImportFiles',
  'canExportData',
  'canGeneratePrintouts',
  'canViewAlerts',
  'canEditAlerts',
  'canViewConfiguration',
  'canReadDatabaseLogin',
] as const

export type PermissionFlag = (typeof PERMISSION_FLAGS)[number]

export type PermissionSet = Record<PermissionFlag, boolean>

/** system = wbudowana, shared = stara wspólna (tylko odczyt), company/serviceAccount = własna. */
export type CompanyRoleScope = 'system' | 'shared' | 'company' | 'serviceAccount' | 'parent'

export type CompanyRole = PermissionSet & {
  id: number
  name: string
  description: string | null
  systemRole: boolean
  isDriver: boolean
  ownerCompanyId: string | null
  scope: CompanyRoleScope
  ownerCompanyName: string | null
  canEdit: boolean
  usersInCompany: number
  usersAffected: number | null
}

export type CompanyRoles = {
  canManage: boolean
  roles: CompanyRole[]
}

export type CompanyRoleInput = PermissionSet & {
  name: string
  description: string | null
}

export const emptyPermissions = (): PermissionSet =>
  Object.fromEntries(PERMISSION_FLAGS.map((f) => [f, false])) as PermissionSet

export const pickPermissions = (source: Partial<PermissionSet>): PermissionSet =>
  Object.fromEntries(PERMISSION_FLAGS.map((f) => [f, !!source[f]])) as PermissionSet
